import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c10b879"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "nge-cmd-input-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cmd-input-icon" }, "⌘", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", { class: "nge-cmd-esc" }, "ESC", -1 /* HOISTED */))
const _hoisted_5 = { class: "nge-cmd-results" }
const _hoisted_6 = {
  key: 0,
  class: "nge-cmd-empty"
}
const _hoisted_7 = { class: "nge-cmd-category" }
const _hoisted_8 = ["onClick", "onMouseenter"]
const _hoisted_9 = { class: "nge-cmd-item-icon" }
const _hoisted_10 = { class: "nge-cmd-item-text" }
const _hoisted_11 = { class: "nge-cmd-item-label" }
const _hoisted_12 = {
  key: 0,
  class: "nge-cmd-item-desc"
}
const _hoisted_13 = {
  key: 0,
  class: "nge-cmd-shortcut"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cmd-footer" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("kbd", null, "↑↓"),
    /*#__PURE__*/_createTextVNode(" navigate")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("kbd", null, "↵"),
    /*#__PURE__*/_createTextVNode(" select")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("kbd", null, "esc"),
    /*#__PURE__*/_createTextVNode(" close")
  ])
], -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "nge-cmd-fade" }, {
      default: _withCtx(() => [
        ($setup.visible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "nge-cmd-backdrop",
              onClick: _withModifiers($setup.close, ["self"])
            }, [
              _createElementVNode("div", {
                class: "nge-cmd-shell",
                onKeydown: $setup.handleKeydown
              }, [
                _createCommentVNode(" Search input "),
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _withDirectives(_createElementVNode("input", {
                    ref: "inputEl",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.query) = $event)),
                    class: "nge-cmd-input",
                    placeholder: "Search actions, cells, tools…",
                    spellcheck: "false",
                    autocomplete: "off"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.query]
                  ]),
                  _hoisted_4
                ]),
                _createCommentVNode(" Results list "),
                _createElementVNode("div", _hoisted_5, [
                  ($setup.results.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, "No matches found"))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupedResults, (group) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: group.category
                    }, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString($setup.categoryLabel(group.category)), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: _normalizeClass(["nge-cmd-item", {
                  'nge-cmd-item--selected': $setup.results.indexOf(item) === $setup.selectedIdx,
                }]),
                          onClick: $event => ($setup.execute(item)),
                          onMouseenter: $event => ($setup.selectedIdx = $setup.results.indexOf(item))
                        }, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(item.icon), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(item.label), 1 /* TEXT */),
                            (item.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.description), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          (item.shortcut)
                            ? (_openBlock(), _createElementBlock("kbd", _hoisted_13, _toDisplayString(item.shortcut), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_8))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createCommentVNode(" Footer "),
                _hoisted_14
              ], 32 /* HYDRATE_EVENTS */)
            ], 8 /* PROPS */, _hoisted_1))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}